import axios from "axios";

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL;

export const sendEmailVerification = async (email) => {
    try {
        const { data } = await axios.post(
            `${API_BASE_URL}/send-verification`,
            { email }
        );

        return data;
    } catch (error) {
        console.error("Error sending verification email:", error);

        throw error.response?.data || {
            success: false,
            message: "Failed to send verification email",
        };
    }
};

export const sendPhoneOTP = async (userId, phone) => {
    try {
        const { data } = await axios.post(
            `${API_BASE_URL}/send-phone-otp`,
            {
                userId,
                phone,
            }
        );

        return data;
    } catch (error) {
        console.error("Error sending phone OTP:", error);

        throw error.response?.data || {
            success: false,
            message: "Failed to send OTP",
        };
    }
};

export const verifyPhoneOTP = async (userId, otp) => {
    try {
        const { data } = await axios.post(
            `${API_BASE_URL}/verify-phone-otp`,
            {
                userId,
                otp,
            }
        );

        return data;
    } catch (error) {
        console.error("Error verifying OTP:", error);

        throw error.response?.data || {
            success: false,
            message: "Failed to verify OTP",
        };
    }
};